import slugify from "slugify";

interface DirtyFields {
  checkout_path?: boolean;
}

export const getBasePath = (checkoutPath: string | null | undefined): string =>
  slugify(checkoutPath ?? "", {
    replacement: "-",
    remove: /[*+~.,;()'"!:@]/g,
    lower: true,
  }).split("?coupon_code=")[0];

export const getCouponFromCheckoutPath = (
  checkoutPath: string | null | undefined,
  dirtyFields: DirtyFields,
): string =>
  !dirtyFields.checkout_path
    ? slugify(checkoutPath ?? "", {
        replacement: "-",
        remove: /[*+~.,;()'"!:@]/g,
        lower: false,
      }).split("?coupon_code=")[1] || ""
    : "";
